module.exports = __webpack_public_path__ + "static/media/typea.d2a8cef2.jpg";